<template>
	<div class="form-group subservice-list">
		<label>Subservices</label>
		<add-button :onClick="addItem" />
		<table class="table">
			<thead>
				<tr>
					<th></th>
					<th>Name</th>
					<th>Duration</th>
					<th>Price</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in items" :key="index">
					<td>
						<delete-button :onClick="() => removeItem(index)" />
					</td>
					<td>
						<auto-complete 
							v-model="item.name"
							:list="existingSubservices"
							:onSelect="selectItem(index)"
							:disabled="!!item.id"
						/>
					</td>
					<td>
						<input 
							type="number" 
							placeholder="Duration" 
							v-model="item.duration" 
							:disabled="item.id" 
							class="form-control"
						>
					</td>
					<td>
						<money 
							class="form-control" 
							v-model="item.price" 
							v-bind="money" 
							placeholder="Price" 
							:disabled="item.id" 
						/>
					</td>
				</tr>
				<tr v-show="items.length < 1">
					<td colspan="4" class="text-center">
						Click <add-button :onClick="addItem" /> to add new subservice.
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { defaultFields } from './helpers';
import { moneyTemplate } from '../../helpers';
import { Money } from 'v-money';
import AutoComplete from "../AutoComplete.vue";
import AddButton from '../AddButton.vue';
import DeleteButton from '../DeleteButton.vue';

export default {
	components: {
		Money,
		AddButton,
		DeleteButton,
		AutoComplete,
	},
	props: {
		initialItems: {
			type: Array,
			default: () => [],
		},
		existingSubservices: {
			type: Array,
			default: () => [],
		},
		onItemsUpdate: {
			type: Function,
			required: false,
		},
	},
	data() {
		return {
			items: this.initialItems,
			money: moneyTemplate(),
		}
	},
	watch: {
		initialItems(value) {
			this.items = value;
		}
	},
	methods: {
		addItem() {
			this.items.push(defaultFields());
			this.fireUpdateCallback();
		},
		removeItem(index) {
			this.items = this.items.filter((item, i) => {
				return i != index;
			});
			this.fireUpdateCallback();
		},
		selectItem(index) {
			return selected => {
				let copyFrom = this.existingSubservices.find(item => {
					return item.id == selected.value;
				});
				this.items[index].id = copyFrom.id;
				this.items[index].name = copyFrom.name;
				this.items[index].duration = copyFrom.duration;
				this.items[index].price = copyFrom.price;
				this.fireUpdateCallback();
			}
		},
		fireUpdateCallback() {
			if (typeof this.onItemsUpdate === 'function') {
				this.onItemsUpdate([...this.items]);
			}
		},
	}
}
</script>
